__turbopack_context__.v({
  "paymentMethodIcon": "PaymentMethodIcon-module__-I9dLW__paymentMethodIcon",
});
